class TreeService {
  renderFolderIconColor(treeNode) {
    if (treeNode.stateColor) {
      if (treeNode.stateColor.includes('orange')) {
        return { color: 'orange' }
      }

      if (treeNode.stateColor.includes('blue')) {
        return { color: 'blue' }
      }

      if (treeNode.stateColor.includes('green')) {
        return { color: 'green' }
      }

      if (treeNode.stateColor.includes('red')) {
        return { color: 'red' }
      }

      if (treeNode.stateColor.includes('NoneSelected')) {
        return { color: '#2eaae2' }
      }
    }
    else{
        return { color: '#2eaae2' }
    }
  }

  renderBoldStyle(treeNode) {
    if (
      treeNode.textBoldStyle &&
      treeNode.textBoldStyle.value &&
      treeNode.textBoldStyle.value === 'bold'
    ) {
      return { fontWeight: 'bold' }
    }
  }

  renderItalicStyle(treeNode) {
    if (
      treeNode.textItalicStyle &&
      treeNode.textItalicStyle.value &&
      treeNode.textItalicStyle.value === 'italic'
    ) {
      return { fontStyle: 'italic' }
    }
  }

  renderTextSize(treeNode) {
    if (treeNode.textSize && treeNode.textSize.option === 'medium') {
      return { fontSize: '14px' }
    } else if (treeNode.textSize && treeNode.textSize.value) {
      return { fontSize: treeNode.textSize.value }
    }
  }

  renderTreeNodeIconStyles(treeNode) {
    let style = {}
    const color = this.renderFolderIconColor(treeNode)
    const bold = this.renderBoldStyle(treeNode)
    const italic = this.renderItalicStyle(treeNode)
    const textSize = this.renderTextSize(treeNode)

    style = { ...color, ...bold, ...italic, ...textSize }
    return style
  }

  renderTreeNodeTextStyles(treeNode) {
    let style = {}
    const bold = this.renderBoldStyle(treeNode)
    const italic = this.renderItalicStyle(treeNode)
    const textSize = this.renderTextSize(treeNode)
    const userSelect = { userSelect: 'none' }

    style = { ...bold, ...italic, ...textSize, ...userSelect }
    return style
  }
}

const treeService = new TreeService()
export default treeService
